/**
 * 审批模板数据：[templateType：控件类型 | type:用于校验 | templateName:控件名称 | tip：说明提示 | must：是否必填 | option：内容选项（单选框时需要）]
 * templateType：0文本 | 1日期+时间 | 2单选框 | 3附件（附件以文件方式上传）
 * must：true必填 | false非必填
 * tempName:模板名称
 */

const tempName = '模板类型名称'

const TemplateList = [
	{
		templateType:0,
		type:'input',
		name:'客户名称',
		placeholder:'请输入内容',
		required:true,
		value:''
	},
	{
		templateType:1,
		type:'datetime',
		name:'下单时间',
		placeholder:'请选择日期时间',
		required:true,
		value:''
	},
	{
		templateType:2,
		type:'radio',
		name:'客户类型',
		placeholder:'请选择客户类型',
		required:true,
		options:[''],
		value:''
	},
	{
		templateType:3,
		type:'file',
		name:'合同附件',
		placeholder:'请上传附件',
		required:true,
		value:''
	}
]
export default {
	TemplateList:TemplateList,
	tempName:tempName
}